module.exports = __webpack_public_path__ + "03_bob_brown.e157a382.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/03_bob_brown.png
// module id = 5aqv
// module chunks = 0